/*!

=========================================================
* Argon Dashboard Chakra - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-chakra
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-chakra/blob/master/LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter,Router, Route, Switch, HashRouter, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import AuthLayout from "layouts/Auth.js";
import RTLLayout from "layouts/RTL.js"; // Chakra imports
import { ChakraProvider } from "@chakra-ui/react";
// Custom Chakra theme
import theme from "theme/theme.js";
import sendcode from "./views/Auth/SendCode";
import verifycode from "./views/Auth/VerifyCode";
import signin from "./views/Auth/SignIn";
import dashboard from "./views/Dashboard/Dashboard";
import { setGlobal } from "config/global";
import me from "api/authenticate/me";


var run=function(){
  var hist = createBrowserHistory();
  ReactDOM.render(
    <ChakraProvider theme={theme} resetCss={false} position="relative">
      <BrowserRouter history={hist}>
        <Switch>
          <Route path={`/admin`} component={RTLLayout} />
          <Route path={`/auth`} component={AuthLayout} />
          <Route path="/auth/sendcode" component={sendcode} />
          <Route path="/auth/verifycode" component={verifycode} />
          <Route path="/auth/signin" component={signin} />
          <Route path="/admin/dashboard" component={dashboard} />
          <Redirect from={`/`} to={main} />
        </Switch>
      </BrowserRouter>
    </ChakraProvider>,
    document.getElementById("root")
  );
}
//http://localhost:3000/admin/payment/callback/?Authority=000000000000000000000000000001196571&Status=OK
let main = "/admin/dashboard";
let token = localStorage.getItem('token')
if (token == null){
  main = "/auth/signin";
  run()
}
else{
  me().then((data)=>{
    console.log(data)
    setGlobal({me:data?.data});
    run()
  })
}

